module.exports = {
  NEW: 'new',
  OPEN: 'open',
  CONTACTED: 'contacted',
  QUALIFIED: 'qualified',
  DISQUALIFIED: 'disqualified',
};

// New: The lead was entered into the system (manually or via import or via some other means)
// and hasn't been contacted yet.

// Open: Still no contact, sales rep has been assigned

// Contacted: One of your sales reps initiated some sort of communication
// and got in touch with the lead

// Qualified: The lead is interested in your product and the sales process should begin.
// This is when the lead can be converted to an Account, Contact and/or Opportunity

// Unqualified: The lead won't be a part of your sales process and is set to Unqualified and there
// can be a multitude of reasons behind this like the person not being interested in your product
// or anything else.
